import { render, staticRenderFns } from "./Commod.vue?vue&type=template&id=c0b9a59c&scoped=true"
import script from "./Commod.vue?vue&type=script&lang=js"
export * from "./Commod.vue?vue&type=script&lang=js"
import style0 from "./Commod.vue?vue&type=style&index=0&id=c0b9a59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b9a59c",
  null
  
)

export default component.exports